// sd1.js - Steel Door Configuration 1
// Wrapper component that uses the SD template

import React from 'react';
import SD from './sd';

const SD1 = () => {
  return (
    <SD
      documentType="steeldoors"
      itemPath="stdoors/sdt/sd1"
      // DrawComponent={DrawSteelDoor}  // uncomment when drawing is built
    />
  );
};

export default SD1;
